import { useState, useEffect } from "react";
import BarraSuperior from "../barra_superior";
import AnimacionCarga from "../animacion_de_carga";
import "../../css/animacion_de_carga.css";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart,
  RadialLinearScale,
  PointElement,
  LineController,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ArcElement,
} from 'chart.js';
import { obtenerCenso } from "../../../functions/consultas";
import { crearGrafica, crearTitulo } from "../../../functions/gestion";

const EstadisticaCenso = () => {
  const [animacionCarga, setCargando] = useState(true);
  const [datosMostrar, setDatosMostrar] = useState(false);
  const [graficaMostrar, setGraficaMostrar] = useState(true);
  const [estadisticas, setEstadisticas] = useState(null);
  const CONFIG_CAMPOS = {
    residentes: { patron: /^nombre_residente_(\d+)$/, campos: ['genero_residente', 'tipo_residente'] },
    vehiculos: { patron: /^placa_(\d+)$/, campos: ['marca_carro', 'color_carro'] },
    mascotas: { patron: /^nombre_mascota_(\d+)$/, campos: ['tipo_mascota'] },
    autorizados: { patron: /^nombre_autorizado_(\d+)$/, campos: ['tipo_relacion_autorizado'] },
    espacios: { patron: /^espacio_identificador_(\d+)$/, campos: ['espacio_tipo'] },
    contactos: { patron: /^nombre_contacto_emergencia_(\d+)$/, campos: [] }
  };

  const procesarCenso = (censo) => {
    const stats = {
      generoResidente: {},
      tipoResidente: {},
      tipoMascota: {},
      marcaVehiculo: {},
      colorVehiculo: {},
      tipoEspacio: {},
      tipoRelacionAutorizado: {},
      contadores: {
        totalViviendas: Object.keys(censo).length,
        totalResidentes: 0,
        totalVehiculos: 0,
        totalMascotas: 0,
        totalAutorizados: 0,
        totalEspacios: 0,
        totalContactosEmergencia: 0
      }
    };

    const incrementar = (obj, key) => {
      if (key && key.toLowerCase() !== 'null' && key !== 'undefined') {
        obj[key] = (obj[key] || 0) + 1;
      }
    };

    Object.values(censo).forEach(vivienda => {
      Object.keys(vivienda).forEach(key => {
        const matchRes = key.match(CONFIG_CAMPOS.residentes.patron);
        if (matchRes && vivienda[key]) {
          const idx = matchRes[1];
          stats.contadores.totalResidentes++;
          incrementar(stats.generoResidente, vivienda[`genero_residente_${idx}`]);
          incrementar(stats.tipoResidente, vivienda[`tipo_residente_${idx}`]);
        }
        const matchVeh = key.match(CONFIG_CAMPOS.vehiculos.patron);
        if (matchVeh && vivienda[key]) {
          const idx = matchVeh[1];
          stats.contadores.totalVehiculos++;
          incrementar(stats.marcaVehiculo, vivienda[`marca_carro_${idx}`]);
          incrementar(stats.colorVehiculo, vivienda[`color_carro_${idx}`]);
        }
        const matchMasc = key.match(CONFIG_CAMPOS.mascotas.patron);
        if (matchMasc && vivienda[key]) {
          stats.contadores.totalMascotas++;
          incrementar(stats.tipoMascota, vivienda[`tipo_mascota_${matchMasc[1]}`]);
        }
        const matchAut = key.match(CONFIG_CAMPOS.autorizados.patron);
        if (matchAut && vivienda[key]) {
          stats.contadores.totalAutorizados++;
          incrementar(stats.tipoRelacionAutorizado, vivienda[`tipo_relacion_autorizado_${matchAut[1]}`]);
        }
        const matchEsp = key.match(CONFIG_CAMPOS.espacios.patron);
        if (matchEsp && vivienda[key]) {
          stats.contadores.totalEspacios++;
          incrementar(stats.tipoEspacio, vivienda[`espacio_tipo_${matchEsp[1]}`]);
        }
        if (CONFIG_CAMPOS.contactos.patron.test(key) && vivienda[key]) {
          stats.contadores.totalContactosEmergencia++;
        }
      });
    });
    const { totalViviendas, totalResidentes, totalVehiculos, totalMascotas } = stats.contadores;
    stats.promedios = {
      residentes: totalViviendas ? (totalResidentes / totalViviendas).toFixed(2) : 0,
      vehiculos: totalViviendas ? (totalVehiculos / totalViviendas).toFixed(2) : 0,
      mascotas: totalViviendas ? (totalMascotas / totalViviendas).toFixed(2) : 0
    };

    return stats;
  };

  const cargarDatos = async () => {
    try {
      const censo = await obtenerCenso();
      if (censo && Object.keys(censo).length > 0) {
        setEstadisticas(procesarCenso(censo));
      }
    } catch (error) {
      console.error("Error capturando datos:", error);
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    Chart.register(
      RadialLinearScale, PointElement, LineElement, LineController,
      Filler, Tooltip, Legend, CategoryScale, LinearScale,
      BarElement, Title, ArcElement, ChartDataLabels
    );
    cargarDatos();
  }, []);

  const renderGrafica = (tipo, titulo, datos) => {
    if (!datos || Object.keys(datos).length === 0) return null;
    return (
      <>
        {crearGrafica('barra', titulo, datos, 600, 1300, "texto", graficaMostrar, datosMostrar)}
        <br />
      </>
    );
  };

  if (animacionCarga) return <AnimacionCarga />;

  return (
    <div>
      <BarraSuperior />
      <div className="BloqueModulo">
        <div style={{ padding: '0px 10px 0px 0px', textAlign: 'right' }}>
          <br />
          <h2>Opciones de visualización</h2>
          <br />
          <label>
            <input type="checkbox" checked={graficaMostrar} onChange={(e) => setGraficaMostrar(e.target.checked)} />
            Mostrar Gráfica de datos
          </label>
          <br />
          <label>
            <input type="checkbox" checked={datosMostrar} onChange={(e) => setDatosMostrar(e.target.checked)} />
            Mostrar Tabla de datos
          </label>
        </div>

        {estadisticas && (
          <div>
            {crearTitulo('Estadísticas de Censo')}
            <br />
            <p>• RESUMEN GENERAL</p>
            <br />
            <table id="table" className="tabla-responsive">
              <thead>
                <tr><th>Concepto</th><th>Total</th></tr>
              </thead>
              <tbody>
                <tr><td>Viviendas</td><td>{estadisticas.contadores.totalViviendas}</td></tr>
                <tr><td>Residentes</td><td>{estadisticas.contadores.totalResidentes}</td></tr>
                <tr><td>Vehículos</td><td>{estadisticas.contadores.totalVehiculos}</td></tr>
                <tr><td>Mascotas</td><td>{estadisticas.contadores.totalMascotas}</td></tr>
                <tr><td>Personas Autorizadas</td><td>{estadisticas.contadores.totalAutorizados}</td></tr>
                <tr><td>Espacios</td><td>{estadisticas.contadores.totalEspacios}</td></tr>
                <tr><td>Contactos de Emergencia</td><td>{estadisticas.contadores.totalContactosEmergencia}</td></tr>
              </tbody>
            </table>
            <br />

            {renderGrafica('barra', 'Género de Residentes', estadisticas.generoResidente)}
            {renderGrafica('barra', 'Tipo de Residente (Propietario, Locatario, etc.)', estadisticas.tipoResidente)}
            {renderGrafica('barra', 'Cantidad de Mascotas por Tipo', estadisticas.tipoMascota)}
            {renderGrafica('barra', 'Marcas de Vehículos más Comunes', estadisticas.marcaVehiculo)}
            {renderGrafica('barra', 'Colores de Vehículos más Comunes', estadisticas.colorVehiculo)}
          </div>
        )}
      </div>
    </div>
  );
};

export default EstadisticaCenso;